import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontAngkor, fontFredoka, theme, transientOptions } from "shared/lib/styles";

import IconQuote from "./quote.svg";
import IconStar from "./star.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  ${theme.breakpoints.up("desktop")} {
    align-items: center;

    text-align: center;
  }
`;

export const Comment = styled.div`
  margin-block-end: 24px;

  font-size: 20px;
  font-family: ${fontAngkor};
  line-height: 26px;
  letter-spacing: -0.03em;

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 40px;

    font-size: 40px;
    line-height: 52px;
  }
`;

export const Name = styled.div`
  font-size: 20px;
  font-family: ${fontFredoka};
  line-height: 28px;
  letter-spacing: -0.01em;
  ${theme.breakpoints.up("desktop")} {
    font-size: 32px;
    line-height: 44.8px;
  }
`;

type StarProps = {
  $isActive?: boolean;
};

export const Quote = styled(IconQuote)`
  inline-size: 66px;
  block-size: 40px;
  margin-block-end: 24px;
  ${theme.breakpoints.up("desktop")} {
    inline-size: 86px;
    block-size: 52px;
    margin-block-end: 32px;
  }
`;

export const Star = styled(IconStar, { ...transientOptions })<StarProps>`
  inline-size: 33px;
  block-size: 32px;
  ${theme.breakpoints.up("desktop")} {
    inline-size: 49px;
    block-size: 48px;
  }
  path#star__color {
    ${props =>
      props.$isActive
        ? null
        : css`
            fill: #ffffff;
          `}
  }
`;

export const Stars = styled.div`
  display: flex;
  align-items: center;

  margin-block-end: 14px;

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 20px;
  }
  ${Star} {
    &:not(:last-child) {
      margin-inline-end: 20px;
    }
  }
`;
